export default class Address {
  jsonData;

  constructor(jsonData) {
    this.jsonData = jsonData;
  }

  getStreet() {
    return this.jsonData.street;
  }

  getLat() {
    return this.jsonData.latitude;
  }

  getLng() {
    return this.jsonData.longitude;
  }

  getFullStreetNumber() {
    return this.jsonData.street_number;
  }

  getHouseNumberWithoutAddition(): string {
    const matches: RegExpExecArray = this.getStreetNumberMatches();
    return matches ? matches[1] : null;
  }

  getHouseNumberAddition(): string {
    const matches: RegExpExecArray = this.getStreetNumberMatches();
    return matches ? matches[2] : null;
  }

  getPostalCode() {
    return this.jsonData.postal_code;
  }

  getCity() {
    return this.jsonData.city;
  }

  getAddressLine() {
    return (
      this.getStreet() +
      ' ' +
      this.getFullStreetNumber() +
      ', ' +
      this.getPostalCode() +
      ' ' +
      this.getCity()
    );
  }

  private getStreetNumberMatches() {
    const regex: RegExp = /(\d+)([a-zA-Z]*)/;
    return this.getFullStreetNumber().match(regex);
  }
}
